import { Instagram, MapPin, Calendar } from "lucide-react";
import { TopoEmblem } from "@/components/Logo";

function TikTokIcon({ className }) {
  return (
    <svg viewBox="0 0 24 24" className={className} fill="currentColor" aria-hidden="true">
      <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5.8 20.1a6.34 6.34 0 0 0 10.86-4.43V9.55a8.16 8.16 0 0 0 4.77 1.52V7.63a4.85 4.85 0 0 1-1.84-.94z" />
    </svg>
  );
}

export default function Footer() {
  return (
    <footer className="bg-[#14230A] text-[#FDF0DF] mt-20 relative overflow-hidden">
      <div className="grain absolute inset-0 pointer-events-none" />
      <div className="max-w-[1440px] mx-auto px-6 md:px-10 py-16 md:py-24 relative">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3">
              <div className="border-2 border-[#FDF0DF] p-2">
                <TopoEmblem className="w-10 h-10" color="#FDF0DF" />
              </div>
              <div>
                <div className="font-display text-2xl tracking-[0.15em]">TRÉSORS</div>
                <div className="font-display text-2xl tracking-[0.15em]">DE GUYANE</div>
              </div>
            </div>
            <p className="mt-5 text-sm leading-relaxed opacity-80 max-w-md">
              Ambassadeur d’une excellence guyanaise — biodiversité amazonienne, patrimoine culturel,
              gastronomique et artisanal. On débarque sur la Grand’Place pour URBX 2026.
            </p>
            <a
              href="https://tresorsdeguyane.fr"
              target="_blank"
              rel="noopener noreferrer"
              className="mt-5 inline-flex items-center gap-2 font-cond uppercase tracking-[0.25em] text-xs hover:text-[#FF4D00] transition-colors"
            >
              tresorsdeguyane.fr →
            </a>
          </div>

          <div className="md:col-span-3">
            <div className="font-cond uppercase tracking-[0.3em] text-[11px] opacity-60 mb-3">
              L’événement
            </div>
            <div className="space-y-2 text-sm">
              <div className="flex gap-2 items-start">
                <Calendar className="w-4 h-4 mt-0.5 flex-shrink-0" />
                Samedi 20 juin 2026
              </div>
              <div className="flex gap-2 items-start">
                <MapPin className="w-4 h-4 mt-0.5 flex-shrink-0" />
                Grand’Place de Roubaix, 59100
              </div>
              <div className="opacity-70 pt-1">Ouverture 19h · 20h → 00h</div>
            </div>
          </div>

          <div className="md:col-span-4">
            <div className="font-cond uppercase tracking-[0.3em] text-[11px] opacity-60 mb-3">
              Suivre
            </div>
            <div className="flex flex-wrap gap-3">
              <a
                href="https://www.instagram.com/tresorsdeguyane/"
                target="_blank"
                rel="noopener noreferrer"
                className="px-4 h-10 border-2 border-[#FDF0DF] inline-flex items-center gap-2 font-cond uppercase tracking-[0.15em] text-xs hover:bg-[#FF4D00] hover:border-[#FF4D00]"
              >
                <Instagram className="w-4 h-4" /> @tresorsdeguyane
              </a>
              <a
                href="https://www.tiktok.com/@tresorsdeguyane"
                target="_blank"
                rel="noopener noreferrer"
                className="px-4 h-10 border-2 border-[#FDF0DF] inline-flex items-center gap-2 font-cond uppercase tracking-[0.15em] text-xs hover:bg-[#FF4D00] hover:border-[#FF4D00]"
                aria-label="TikTok"
              >
                <TikTokIcon className="w-4 h-4" /> @tresorsdeguyane
              </a>
            </div>
            <div className="mt-6 text-[11px] opacity-60 leading-relaxed">
              L’abus d’alcool est dangereux pour la santé. À consommer avec modération.
              <br /> Vente d’alcool interdite aux mineurs.
            </div>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-[#FDF0DF]/20 flex flex-col md:flex-row justify-between gap-2 text-[11px] opacity-60 font-cond tracking-widest uppercase">
          <span>© 2026 Trésors de Guyane × URBX Festival · tresorsdeguyane.fr</span>
          <span>Made with rhum et code</span>
        </div>
      </div>
    </footer>
  );
}
